const PATH = 'fe.pages.set_password';

const messages = {
  setYourPassword: {
    key: `${PATH}.set_your_password`,
    defaultValue: 'Set your password'
  },
  password: {
    key: `${PATH}.password`,
    defaultValue: 'Password'
  },
  confirmPassword: {
    key: `${PATH}.confirm_password`,
    defaultValue: 'Confirm Password'
  },
  passwordSet: {
    key: `${PATH}.password_set`,
    defaultValue: 'Your password was set!'
  },
  reEnterPassword: {
    key: `${PATH}.re_enter_password`,
    defaultValue: 'Re-enter password'
  },
  setMyPassword: {
    key: `${PATH}.set_my_password`,
    defaultValue: 'Set my password'
  },
  errors: {
    generic: {
      key: `${PATH}.errors.generic`,
      defaultValue: 'Something went wrong. Please try again.'
    },
    password: {
      required: {
        key: `${PATH}.errors.password.required`,
        defaultValue: 'Password is required'
      },
      minChars: {
        key: `${PATH}.errors.password.min_chars`,
        defaultValue: 'Password must contain at least 6 characters'
      }
    },
    confirmPassword: {
      required: {
        key: `${PATH}.errors.confirm_password.required`,
        defaultValue: 'Password Confirmation is required'
      },
      mustMatch: {
        key: `${PATH}.errors.confirm_password.must_match`,
        defaultValue: 'Passwords must match'
      }
    },
    checkbox: {
      required: {
        key: `${PATH}.errors.checkbox.required`,
        defaultValue:
          'To continue you must agree to the Terms of Service and Privacy Policy.'
      }
    },
    sessionExpired: {
      key: `${PATH}.errors.session_expired`,
      defaultValue:
        'You may have already changed your expired password or need to start over. Please try signing in again.'
    },
    invalidResetToken: {
      key: `${PATH}.errors.invalid_reset_token`,
      defaultValue:
        'This password reset link is invalid or has expired. Please request a new one.'
    }
  },
  termsOfService: {
    privacy01: {
      key: `${PATH}.terms_service.privacy_01`,
      defaultValue: 'I agree to the Teachstone'
    },
    privacy02: {
      key: `${PATH}.terms_service.privacy_02`,
      defaultValue: 'Terms of Service'
    },
    privacy03: {
      key: `${PATH}.terms_service.privacy_03`,
      defaultValue: 'and'
    },
    privacy04: {
      key: `${PATH}.terms_service.privacy_04`,
      defaultValue: 'Privacy Policy'
    }
  }
};

export default messages;
